import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-head-estadistico',
  templateUrl: './head-estadistico.component.html',
  styleUrls: ['./head-estadistico.component.css']
})
export class HeadEstadisticoComponent implements OnInit {

  @Input() icono: string[];
  @Input() texto: string[];
  @Input() txttotal: string;
  @Input() txtactivos: string;
  @Input() txtbajas: string;
  @Input() total: number;
  @Input() activos: number;
  @Input() bajas: number;

  @Input() numeros: any[];

  constructor() { }

  ngOnInit(): void {
  }

}
